var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.459 -0.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(-0.459 0.324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    width: 22,
    height: 21,
    rx: 3,
    transform: "translate(0 0)",
    fill: "#0077b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.352 3.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M37.156,34.878A1.878,1.878,0,1,1,35.278,33,1.878,1.878,0,0,1,37.156,34.878Z",
    transform: "translate(-33.4 -33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5057",
    "data-name": "Path 5057",
    d: "M39.67,69.746v8.3a.464.464,0,0,1-.464.467H37.226a.464.464,0,0,1-.466-.466v-8.3a.466.466,0,0,1,.466-.466h1.979A.466.466,0,0,1,39.67,69.746Z",
    transform: "translate(-36.339 -64.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5058",
    "data-name": "Path 5058",
    d: "M79.506,73.1v4.016a.427.427,0,0,1-.428.428H76.949a.427.427,0,0,1-.428-.428V73.227c0-.581.17-2.544-1.519-2.544-1.308,0-1.575,1.343-1.628,1.947v4.49a.428.428,0,0,1-.422.428H70.9a.427.427,0,0,1-.427-.428V68.747a.427.427,0,0,1,.427-.428h2.056a.428.428,0,0,1,.428.428v.724a2.914,2.914,0,0,1,2.742-1.291C79.526,68.18,79.506,71.358,79.506,73.1Z",
    transform: "translate(-65.829 -63.776)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.13e66be3b333b675798a5811b35f180d.svg";
export { ForwardRef as ReactComponent };